// @ts-check
import jQuery from 'jquery';
import { debounce } from "../utilities/debounce";
import { toggleBooleanAttribute } from '../utilities/attributes';

// @ts-ignore
jQuery( function( $ ) {
    const menus = /** @type {HTMLElement[]} */( [...document.querySelectorAll( '.menusting' )] );
    menus.forEach( menu => {
        new TabGroups( menu );
    } );
} );

class TabGroups {
    /**
     * @param {HTMLElement} element
     */
    constructor( element ) {
        this.main = element;
        /** @type {'mobile'|'desktop'} */
        this.state = 'desktop';
        this.scroller = /** @type {HTMLElement} */( element.querySelector( '.menusting__main' ) );

        this.buttons = /** @type {HTMLElement[]} */( [...element.querySelectorAll( '[data-term]' )] );

        this.groups = /** @type {HTMLElement[]} */( [...element.querySelectorAll( '[data-group]' )] );

        this.buttons.forEach( button => button.addEventListener( 'click', this.filter ) );

        this.watcher = window.matchMedia( '(min-width: 768px)' );
        if ( !this.watcher.matches ) {
            this._activateMobileMode();
        }
        this.watcher.addEventListener( 'change', this._toggleMode );

        // Ensure resizing the window doesn't f**k up the scroll positioning, simply 'reshows' the currently active group after resizing
        /** @ts-ignore */
        window.addEventListener( 'resize', debounce( () => {
            const activatedTerm = this.buttons.filter( btn => btn.dataset.active === 'true' )?.[0]?.dataset?.term;
            if ( !activatedTerm ) return;
            this.showGroup( activatedTerm );
        }, 300 ), { passive: true } );
    }

    /**
     * @param {MouseEvent} e
     */
    filter = ( e ) => {
        const button = e.currentTarget;
        if ( !( button instanceof HTMLElement ) ) return;
        this.deactivateButtons();
        this._activate( button );
        const termId = button.dataset.term ?? '';
        this.showGroup( termId );
    };

    deactivateButtons() {
        this.buttons.forEach( this._deactivate );
    }

    /**
     * @param {string} termId
     */
    showGroup( termId ) {
        this.groups.forEach( group => {
            ( group.dataset.group === termId ) ?
                this._show( group ) :
                this._hide( group );
        }
        );
    }

    /**
     * @param {HTMLElement} group
     */
    _hide = ( group ) => {
        group.dataset['active'] = 'false';
        group.ariaHidden = 'true';
    };
    /**
     * @param {HTMLElement} group
     */
    _show = ( group ) => {
        if ( this.state === 'desktop' ) {
            if ( this.scroller.scrollTo ) {
                this.scroller.scrollTo( { left: group.offsetLeft, top: 0, behavior: 'smooth' } );
            } else {
                this.scroller.scrollLeft = group.offsetLeft;
            }
        }
        group.dataset['active'] = 'true';
        group.ariaHidden = 'false';
    };

    /**
     * @param {HTMLElement} button
     */
    _activate( button ) {
        button.dataset['active'] = 'true';
    }

    /**
     * @param {HTMLElement} button
     */
    _deactivate( button ) {
        button.dataset['active'] = 'false';
    }

    _activateMobileMode() {
        this.buttons.forEach( button => {
            const group_id = button.dataset.term;
            const group = this.scroller.querySelector( `[data-group="${group_id}"]` );
            if ( !group ) return;
            button.after( group );

            button.addEventListener( 'click', this._mobileTabClick );
            if ( button.dataset.active !== 'true' ) jQuery( group ).slideUp();

            this.state = 'mobile';
        } );
    }

    _mobileTabClick = ( e ) => {
        const button = e.currentTarget;
        const id = button.dataset.term;
        this.groups.forEach( item => {
            if ( item.dataset.group === id ) {
                if ( item.style.display === 'none' ) {
                    jQuery( item ).slideDown();
                    button.dataset.active = 'true';
                } else {
                    jQuery( item ).slideUp();
                    button.dataset.active = 'false';
                }
            } else if ( item.style.display !== 'none' ) jQuery( item ).slideUp();
        } );
    };

    _deactivateMobileMode() {
        this.buttons.forEach( button => {
            button.removeEventListener( 'click', this._mobileTabClick );

            if ( button.dataset.active ) requestAnimationFrame( () => button.click() );
        } );
        this.groups.forEach( group => {
            group.style.display = '';
            this.scroller.append( group );
        } );
        this.state = 'desktop';
    }

    /**
     *
     * @param {MediaQueryListEvent} e
     */
    _toggleMode = ( e ) => {
        if ( this.watcher.matches && this.state === 'mobile' ) {
            this._deactivateMobileMode();
        } else if ( this.state === 'desktop' ) {
            this._activateMobileMode();
        }
    };
}